import { IRatingScaleProps } from './IRatingScaleProps';
import { RatingScaleNumber } from './RatingScaleNumber';

/** Шкала по умолчанию 0..5 */
export const RatingScaleDefault = (props: IRatingScaleProps) => (
    <RatingScaleNumber {...props} scaleClassName="offer-crit-rating-scale-default" />
);
